/* A porta ao lado: troca os itens da loja pelos do Decor, na mesma linha. */
(function () {
  'use strict';

  function montar(raiz) {
    if (raiz.hasAttribute('data-pdec-pronto')) return;
    raiz.setAttribute('data-pdec-pronto', '');

    var botao = raiz.querySelector('[data-pdec-abrir]');
    var eti = raiz.querySelector('[data-pdec-eti]');
    if (!botao) return;

    var cabeca = raiz.closest('.header__content');
    var caixa = cabeca || raiz.closest('.main-drawer-menu, .main-sidebar, .menu-container, .sidebar')
      || raiz.closest('section, aside');
    // A gaveta tem duas listas — a de computador e a de telemovel — e uma
    // delas esta sempre escondida. Escolhe-se a que esta a ser vista, senao a
    // porta muda-se para dentro da lista errada e desaparece.
    var lista = caixa && [].slice.call(caixa.querySelectorAll('ul.menu__list'))
      .filter(function (u) { return u.offsetParent; })[0];
    // Fora do cabeçalho — gaveta do telemóvel, barra lateral — a porta toma a
    // forma de acordeão do tema em vez da fila. E o contexto que manda, nao a
    // largura do ecra: a gaveta tambem existe em ecras largos.
    if (!cabeca) raiz.classList.add('pdec--gaveta');
    var fila = raiz.querySelector('[data-pdec-fila]');
    var banda = raiz.querySelector('[data-pdec-banda]');

    // A palavra entra na lista do menu em vez de ficar ao lado dela: assim
    // herda o espacamento e o alinhamento dos outros itens, sem os imitar.
    if (lista && !raiz.closest('.menu__list')) {
      var casa = document.createElement('li');
      casa.className = 'menu__item pdec__casa';
      raiz.parentNode.insertBefore(casa, raiz);
      casa.appendChild(raiz);
      lista.appendChild(casa);
    }

    // A fila e a banda saem para o <body>. O cabecalho do tema tem `transform`
    // (a barra sticky), e um antepassado com transform passa a ser o bloco de
    // referencia do `position: fixed` — ficavam 44px abaixo da linha do menu,
    // por muito bem que se medisse. No body nao ha nada a ancora-las.
    if (cabeca) {
      // marcadas porque, uma vez no <body>, deixam de ter .pdec por cima e
      // nenhuma regra as consegue apanhar pelo contexto
      if (fila) { fila.classList.add('pdec__solto'); document.body.appendChild(fila); }
      if (banda) { banda.classList.add('pdec__solto'); document.body.appendChild(banda); }
    }

    // A tinta e copiada de um link real do menu, nunca adivinhada: assim a
    // porta acompanha o cabecalho em qualquer pagina (transparente sobre o
    // heroi, solido nas colecoes, escuro nos candeeiros).
    // A porta nao escolhe tipografia nenhuma: espelha a de um item real do
    // menu. E o que a faz seguir o padrao em qualquer sitio — cabecalho de
    // computador, barra lateral do telemovel — sem eu adivinhar valores.
    function espelhar() {
      if (!caixa) return;
      // A gaveta nao usa `.menu__item a` — usa `.menu__item-link`. Procura-se
      // pela ordem, e ignora-se qualquer coisa que ja seja da porta.
      var ref = null;
      ['.menu__item:not(.pdec__casa) a', '.menu__item-link', '.menu__item-link-title']
        .some(function (sel) {
          ref = [].slice.call(caixa.querySelectorAll(sel))
            .filter(function (e) { return !e.closest('[data-pdec]') && e.offsetParent; })[0];
          return !!ref;
        });
      if (!ref) return;
      var c = getComputedStyle(ref.querySelector('span') && ref.querySelector('span').textContent.trim() ? ref : ref);
      var e = raiz.style;
      var g = cabeca ? document.documentElement.style : null;
      var por = function (k, v) { e.setProperty(k, v); if (g) g.setProperty(k, v); };
      por('--pdec-tinta', c.color);
      por('--pdec-tam', c.fontSize);
      por('--pdec-peso', c.fontWeight);
      por('--pdec-esp', c.letterSpacing === 'normal' ? '0' : c.letterSpacing);
      por('--pdec-caixa', c.textTransform);
      por('--pdec-fonte', c.fontFamily);
    }

    // A fila e a banda sao fixas: precisam de saber onde acaba o cabecalho.
    function medir() {
      if (!lista) return;
      var l = lista.getBoundingClientRect();
      var barra = raiz.closest('.header-section, header.header, .header__wrapper');
      var f = barra ? barra.getBoundingClientRect().bottom : l.bottom;
      var d = document.documentElement.style;
      d.setProperty('--pdec-topo', Math.round(l.top) + 'px');
      d.setProperty('--pdec-alt', Math.round(l.height) + 'px');
      d.setProperty('--pdec-fundo', Math.round(f) + 'px');
      // A fila ocupa exactamente a faixa dos itens da loja e pára antes da
      // palavra que a abriu — senão passa-lhe por cima ("PEDIR PROPOSTALOJA").
      var casa = raiz.closest('.pdec__casa');
      var lim = casa ? casa.getBoundingClientRect().left - 15 : l.right;
      d.setProperty('--pdec-esq', Math.round(l.left) + 'px');
      d.setProperty('--pdec-dir', Math.round(Math.max(lim, l.left + 120)) + 'px');
    }

    var pedido = 0;
    function agendar() {
      if (pedido) return;
      pedido = requestAnimationFrame(function () { pedido = 0; medir(); espelhar(); });
    }

    medir(); espelhar();
    // A classe que torna o cabecalho transparente (e branco) e posta pelo tema
    // DEPOIS disto: sem uma segunda leitura, a porta ficava preta sobre o heroi.
    [60, 300, 1200].forEach(function (ms) { setTimeout(agendar, ms); });
    if (cabeca && window.MutationObserver) {
      var alvo = raiz.closest('.header-section') || cabeca;
      new MutationObserver(agendar).observe(alvo, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(agendar).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    addEventListener('resize', agendar);
    addEventListener('scroll', agendar, { passive: true });

    var ligacoes = fila ? [].slice.call(fila.querySelectorAll('.pdec__ligacao')) : [];
    var camadas = banda ? [].slice.call(banda.querySelectorAll('[data-pdec-camada]')) : [];
    var ditos = banda ? [].slice.call(banda.querySelectorAll('[data-pdec-dito]')) : [];

    function acender(i) {
      camadas.forEach(function (c, n) { c.classList.toggle('e-agora', n === i); });
      ditos.forEach(function (d, n) { d.classList.toggle('e-agora', n === i); });
      ligacoes.forEach(function (l, n) { l.classList.toggle('e-agora', n === i); });
    }
    ligacoes.forEach(function (l, i) {
      l.addEventListener('mouseenter', function () { acender(i); });
      l.addEventListener('focus', function () { acender(i); });
    });

    function abrir(sim) {
      if (sim) { raiz.setAttribute('data-aberta', ''); medir(); acender(0); }
      else raiz.removeAttribute('data-aberta');
      if (cabeca) document.documentElement.toggleAttribute('data-pdec-aberta', sim);
      botao.setAttribute('aria-expanded', sim ? 'true' : 'false');
      // a palavra diz o que o toque faz a seguir
      if (eti) eti.textContent = sim ? 'Loja' : 'Decor';
    }

    botao.addEventListener('click', function () { abrir(!raiz.hasAttribute('data-aberta')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') abrir(false); });
    document.addEventListener('click', function (e) {
      var dentro = raiz.contains(e.target)
        || (fila && fila.contains(e.target))
        || (banda && banda.contains(e.target));
      if (!dentro && raiz.hasAttribute('data-aberta')) abrir(false);
    });
  }

  function varrer() {
    [].slice.call(document.querySelectorAll('[data-pdec]')).forEach(montar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer);
  else varrer();
}());

/* ── Dois mundos na mesma linha ───────────────────────────────────────────────
   O Liquid já decide qual dos dois abre: se a página actual pertence ao menu
   Decor (link.active / child_active), a linha abre no Decor. Aqui só se trata
   da troca à mão, e de lembrar a escolha dentro da sessão — quem foi ver os
   serviços e depois clica no logótipo não é atirado de volta sem pedir. */
(function () {
  var raiz = document.querySelector('[data-pdec2]');
  if (!raiz || raiz.dataset.pronto2) return;
  raiz.dataset.pronto2 = '1';

  var CHAVE = 'pistacho_mundo';
  var abas = [].slice.call(raiz.querySelectorAll('[data-pdec2-aba]'));
  var mundos = {};
  [].slice.call(raiz.querySelectorAll('[data-pdec2-mundo]')).forEach(function (m) {
    mundos[m.getAttribute('data-pdec2-mundo')] = m;
  });
  if (!abas.length || !mundos.loja || !mundos.decor) return;

  function mostrar(qual, guardar) {
    Object.keys(mundos).forEach(function (k) {
      var on = k === qual;
      mundos[k].hidden = !on;
      if (on && guardar) {
        mundos[k].classList.remove('e-a-entrar');
        void mundos[k].offsetWidth;          // reinicia a animação
        mundos[k].classList.add('e-a-entrar');
      }
    });
    abas.forEach(function (a) {
      var on = a.getAttribute('data-pdec2-aba') === qual;
      a.classList.toggle('e-agora', on);
      a.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (guardar) { try { sessionStorage.setItem(CHAVE, qual); } catch (e) {} }
  }

  abas.forEach(function (a) {
    a.addEventListener('click', function () { mostrar(a.getAttribute('data-pdec2-aba'), true); });
  });

  // A página manda: se ela é do mundo Decor, é o Decor que abre, aconteça o que
  // acontecer. Só fora disso é que a escolha da sessão conta.
  if (raiz.getAttribute('data-pdec2-inicio') !== 'decor') {
    var guardado = null;
    try { guardado = sessionStorage.getItem(CHAVE); } catch (e) {}
    if (guardado === 'decor') mostrar('decor', false);
  }
})();
